import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['item']

    connect() {
        const options = {
            touch: 'hold',
        }

        // Default delay
        if (!this.element.dataset.tippyDelay) {
            options.delay = [600, 200]
        }

        this.tippy = tippy(this.element, options)
    }

    disconnect() {
        this.tippy.destroy()
    }
}
